export const TTIFFs: string[] = ['uim-1689-gql-fetch-ui-adjustments_zbqgh'];
